<template>
  <div id="ixStats"
    class="cw-container cw-mx-auto cw-px-4 lg:cw-p-0 cw-max-w-full">
    <div class="cw-flex cw-flex-wrap cw-text-center">
      <div id="ixLocations"
        class="cw-w-full">
        <button v-for="location in ixListByNameSorted"
          :key="location"
          class="cw-inline-block cw-align-middle cw-text-center cw-select-none cw-border cw-font-normal cw-whitespace-no-wrap cw-rounded cw-py-2 cw-px-3 cw-leading-tight cw-mr-2 cw-mb-2"
          :class="location === selectedGraph.location ? 'cw-bg-blue-600 cw-text-white' : 'cw-bg-white cw-text-black'"
          @click="displayGraph(ixListByName[location].name)">
          {{ ixListByName[location].name }}
        </button>
      </div>
      <div class="cw-w-full">
        <div class="cw-flex cw-flex-wrap cw-justify-center">
          <div v-if="loading"
            class="cw-mt-5 cw-pt-5 cw-h-[400px]"
            role="status">
            Loading...
          </div>

          <template v-else>
            <Plotly id="graph"
              :data="graphData"
              :options="graphOptions"
              :layout="graphLayout"
              class="cw-flex-grow cw-w-full cw-h-[400px] mx-4 my-0" />

            <div id="metaInfo"
              class="cw-flex cw-flex-wrap cw-text-center cw-gap-4">
              <div>
                <strong>ASN</strong>
                {{ ixListByName[selectedGraph.location].asn }}
              </div>
              <div>
                <strong>IPV4</strong>
                {{ ixListByName[selectedGraph.location].ipv4_network }}
              </div>
              <div>
                <strong>IPV6</strong>
                {{ ixListByName[selectedGraph.location].ipv6_network }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Plotly from './plotly'
import { DateTime } from 'luxon'
import axios from 'axios'

export default {
  name: 'IXStats',

  components: {
    Plotly,
  },

  data() {
    return {
      ixList: [],
      selectedGraph: {
        location: null,
        data: null,
      },
      graphData: [],
      graphOptions: {},
      graphLayout: {},
      loading: true,
    }
  },

  computed: {
    ixListByName() {
      const ixList = {}
      this.ixList.forEach(ix => {
        ixList[ix.name] = ix
      })
      return ixList
    },
    ixListByNameSorted() {
      return Object.keys(this.ixListByName).sort()
    },
  },

  async created() {
    const response = await axios('https://api.megaport.com/v2/ixp')
    this.ixList = response.data.data
    this.displayGraph(this.ixList[0].name)
    this.loading = false
  },

  methods: {
    async displayGraph(graph) {
      this.loading = true
      this.selectedGraph.location = graph
      const url = `https://api.megaport.com/v2/graph/ixAggregate?ixName=${graph}`
      const response = await axios(url)
      this.selectedGraph.data = response.data.data
      this.prepareGraphData()
      this.loading = false
    },
    prepareGraphData() {
      let yAxisOpts = {}
      yAxisOpts = {
        typeMeasurement: 'bps',
        exponentformat: 'SI',
      }
      let multiplier = 1000000

      const minDate = new Date(this.selectedGraph.data.start)
      const maxDate = new Date(this.selectedGraph.data.end)

      const trace1 = {
        x: [],
        y: [],
        mode: 'lines',
        name: 'In',
        line: {
          color: 'rgb(233,31,47)',
        },
      }

      const trace2 = {
        x: [],
        y: [],
        mode: 'lines',
        name: 'Out',
        line: {
          color: 'rgb(6,121,182)',
        },
      }

      this.graphLayout = {
        title: this.selectedGraph.location,
        xaxis: {
          title: `Date ${minDate.toLocaleString(DateTime.DATE_SHORT)} - ${maxDate.toLocaleString(DateTime.DATE_SHORT)}`,
          nticks: 10,
        },
        yaxis: {
          ...yAxisOpts,
        },
        margin: {
          l: 60,
          r: 60,
          t: 60,
          b: 80,
          autoResize: true,
        },
        legend: {
          orientation: 'h',
        },
        hovermode: 'x',
      }

      this.graphOptions = {
        responsive: true,
        displaylogo: false,
        displayModeBar: false,
      }

      this.selectedGraph.data.in_bps.forEach((bps, idx) => {
        const timestamp = new DateTime(minDate).plus({ minutes: idx * 5 }).toFormat('HH:mm')
        trace1['x'].push(timestamp)
        trace1['y'].push(bps * multiplier)
      })

      this.selectedGraph.data.out_bps.forEach((bps, idx) => {
        const timestamp = new DateTime(minDate).plus({ minutes: idx * 5 }).toFormat('HH:mm')
        trace2['x'].push(timestamp)
        trace2['y'].push(bps * multiplier)
      })

      this.graphData = [trace1, trace2]
      this.loading = false
    },
  },
}
</script>
